/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SubcontractorChangeOrderRequestsControllerRemoveMutationResponse, SubcontractorChangeOrderRequestsControllerRemovePathParams, SubcontractorChangeOrderRequestsControllerRemove401, SubcontractorChangeOrderRequestsControllerRemove403, SubcontractorChangeOrderRequestsControllerRemove404 } from "../../models/changeOrdersController/SubcontractorChangeOrderRequestsControllerRemove";

function getSubcontractorChangeOrderRequestsControllerRemoveUrl(id: SubcontractorChangeOrderRequestsControllerRemovePathParams["id"], requestId: SubcontractorChangeOrderRequestsControllerRemovePathParams["requestId"]) {
  const res = { method: 'DELETE', url: `/api/v1/potential-change-orders/${id}/subcontractor-change-order-requests/${requestId}` as const }  
  return res
}

/**
 * @summary Detach a request while leaving its file in Document Crunch
 * {@link /api/v1/potential-change-orders/:id/subcontractor-change-order-requests/:requestId}
 */
export async function subcontractorChangeOrderRequestsControllerRemove(id: SubcontractorChangeOrderRequestsControllerRemovePathParams["id"], requestId: SubcontractorChangeOrderRequestsControllerRemovePathParams["requestId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SubcontractorChangeOrderRequestsControllerRemoveMutationResponse, ResponseErrorConfig<SubcontractorChangeOrderRequestsControllerRemove401 | SubcontractorChangeOrderRequestsControllerRemove403 | SubcontractorChangeOrderRequestsControllerRemove404>, unknown>({ method : "DELETE", url : getSubcontractorChangeOrderRequestsControllerRemoveUrl(id, requestId).url.toString(), ... requestConfig })  
  return res.data
}